module.exports = __webpack_public_path__ + "static/afiche-f15a3585c38e937653397f7b05a47385.pdf";